export default __webpack_public_path__ + "static/media/ESSK34AMET01.e3608aec.mp4";